import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";

import { PageAlert } from "capitalrx-components";

import { uploadTestClaimBatchActions } from "@/App/actions";
import { ActionTypes } from "@/App/constants/actionTypes";
import apiService from "@/App/service";
import { TransmissionTypes } from "@/types";

function* uploadTestClaimBatch(data: { original_name: string }): Generator {
  return yield apiService({
    url: "/transmission/batch_test/url_for_upload",
    method: "POST",
    data,
  });
}

// eslint-disable-next-line
function* uploadToS3(response: TransmissionTypes.TestClaimBatchUploadResponse, payload: any): Generator {
  const data = new FormData();

  for (const [key, value] of Object.entries(response.post.fields)) {
    data.append(key, value);
  }

  data.append("file", payload.excel_file[0]);
  const { url } = response.post;

  return yield apiService(
    {
      url,
      method: "POST",
      data,
    },
    "S3",
  );
}

function* processTestClaimBatch(data: { id: number }): Generator {
  return yield apiService({
    url: "/transmission/batch_test/process",
    method: "POST",
    data,
  });
}

export function* uploadTestClaimBatchWorker(action: ReturnType<typeof uploadTestClaimBatchActions.uploadTestClaimBatch>): SagaIterator {
  const { payload, formName, navigate } = action;
  const { showPageAlert } = PageAlert;
  const data = {
    original_name: payload.excel_file[0].name,
  };

  try {
    yield put(startSubmit(formName));
    const results = yield call(uploadTestClaimBatch, data);
    const { id } = results;
    yield call(uploadToS3, results, payload);
    yield call(processTestClaimBatch, { id });
    navigate(`/test-claim/batch/view/${id}`);
    yield put(showPageAlert({ show: true, type: "success", message: "The test claim batch file was uploaded successfully." }));
    yield put(stopSubmit(formName));
  } catch (error) {
    const { data: { message = "", field_error_messages = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
    yield put(stopSubmit(formName, field_error_messages));
  }
}

export default function* uploadTestClaimBatchWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.UPLOAD_BATCH_TRANSMISSION_TEST_CLAIM_BATCH, uploadTestClaimBatchWorker);
}
